import { render, staticRenderFns } from "./tiyaJob.vue?vue&type=template&id=5d0d4ad3&"
import script from "./tiyaJob.vue?vue&type=script&lang=js&"
export * from "./tiyaJob.vue?vue&type=script&lang=js&"
import style0 from "./tiyaJob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports